import React from "react";
import PendingPharmacist from "../../../components/pharmacist/pendingPharmacists/PendingPharmacist";


function PendingPharmacists() {
  return <PendingPharmacist />;
}

export default PendingPharmacists;
